module.exports = __webpack_public_path__ + "img/jiaowu_mobile3.b8d77402.jpg";